<script lang="ts">
    import { fade } from "svelte/transition"
    export let text: string
    export let style: string
    //export let active
</script>

<div class="tooltip {style}" transition:fade>{text}</div>

<style lang="less">
    div {
        // position: relative;
        background: var(--surface-4);
        color: var(--on-surface-4);
        // border: 1px solid var(--border-color-default);
        padding: 20px;
        border-radius: 5px;
        box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.1);
        transition: all 0.3s;
        position: absolute;
        top: 180%;
        left: inherit;
        right: -7px;
        margin-left: -150px;
        width: 300px;
        z-index: 2000;
        &:before {
            bottom: 100%;
            left: inherit;
            right: 10px;
            border: solid transparent;
            content: "";
            height: 0;
            width: 0;
            position: absolute;
            pointer-events: none;
            border-color: rgba(0, 0, 0, 0);
            border-bottom-color: var(--border-color-default);
            border-width: 11px;
            margin-left: -11px;
        }
    }
    div.top {
        top: auto;
        bottom: 180%;
        height: fit-content;

        &:before {
            bottom: inherit;
            top: 100%;
            border-bottom-color: transparent;
            border-top-color: var(--border-color-default);
        }
    }
</style>
